// extracted by mini-css-extract-plugin
export default {"title":"Form_title__PSDBG","subTitle":"Form_subTitle__mXfcd","buttonText":"Form_buttonText__Uqtrf","border":"Form_border__-wzq7"};